module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "post"
    }
  }, [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Posten")])]), _vm._v(" "), _c('custom-form', {
    attrs: {
      "fields": [{
        name: 'message',
        type: 'textarea',
        title: 'Dein Post'
      }, 'photos'],
      "clearOnSubmit": "",
      "submitLabel": "Posten",
      "url": "timeline/post"
    },
    on: {
      "submitted": _vm.onPosted
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c84ade","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/post.vue
// module id = 221
// module chunks = 0